import Vue from 'vue';
import Vuex from 'vuex';

import rootStore from './rootStore';
import invoiceModule from './invoiceModule';
import billModule from './billModule';
import partnerModule from './partnerModule';
import adModule from './adModule';

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: rootStore.state,
  getters: rootStore.getters,
  mutations: rootStore.mutations,
  actions: rootStore.actions,
  modules: {
    invoiceModule,
    billModule,
    partnerModule,
    adModule,
  },
});
